import CustomAxios from "..";

export const createBlogs = async (formData) => {
    try {
      const response = await CustomAxios.post(
        `/blog/create`,
        formData,
      );
      return response;  
    } catch (error) {
      console.error("Error uploading landing:", error);
      throw error;
    }
};
// export const updateBlogs = async (id,formData) => {
//   try {
//     const response = await CustomAxios.put(
//       `/landing-card/update/${id}`,
//       formData,
//     );
//     return response; 
//   } catch (error) {
//     console.error("Error uploading landing:", error);
//     throw error;
//   }
// };
  
export const getBlogs = async (params={}) => {
  try {
    const response = await CustomAxios.get("/blog/list",{params});
    return response;
  } catch (error) {
    console.error("Error fetching Blogs:", error);
    throw error;
  }
};

export const StatusChangeBlogsById = async (id) => {
  try {
    const response = await CustomAxios.patch(`/blog/update-status/${id}`);
    return response;
  } catch (error) {
    console.error("Error fetching Blogs:", error);
    throw error;
  }
};

export const deleteBlogsById = async (id) => {
  try {
    const response = await CustomAxios.delete(`/blog/${id}`);
    return response;
  } catch (error) {
    console.error("Error fetching Blogs:", error);
    throw error;
  }
};

